/**
 * Indaleti API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserAccountDto } from './userAccountDto';
import { DemoSchoolOwnerDto } from './demoSchoolOwnerDto';


export interface DemoSchoolDto { 
    id: number;
    name: string;
    emisNumber?: string | null;
    isActive: boolean;
    type: DemoSchoolDto.TypeEnum;
    curriculumType: DemoSchoolDto.CurriculumTypeEnum;
    provisioningStatus: DemoSchoolDto.ProvisioningStatusEnum;
    provisioningError?: string | null;
    demoExpiresAt?: string | null;
    createdAt: string;
    /**
     * Profile slug this school was provisioned from, e.g. \"indaleti\".
     */
    demoProfile?: string | null;
    /**
     * Who this demo is for — set at provisioning time.
     */
    demoClientName?: string | null;
    /**
     * Prospect/client email this demo\'s credentials were sent to, if any.
     */
    demoClientEmail?: string | null;
    /**
     * Free-text internal notes about this demo.
     */
    demoNotes?: string | null;
    /**
     * The admin who provisioned this demo school, if known.
     */
    demoOwnerAdmin?: DemoSchoolOwnerDto | null;
    /**
     * Active principal accounts for this demo school
     */
    users: Array<UserAccountDto>;
}
export namespace DemoSchoolDto {
    export const TypeEnum = {
        Public: 'PUBLIC',
        Private: 'PRIVATE',
        Independent: 'INDEPENDENT',
        International: 'INTERNATIONAL'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
    export const CurriculumTypeEnum = {
        Caps: 'CAPS',
        Ieb: 'IEB',
        Cambridge: 'CAMBRIDGE',
        Other: 'OTHER'
    } as const;
    export type CurriculumTypeEnum = typeof CurriculumTypeEnum[keyof typeof CurriculumTypeEnum];
    export const ProvisioningStatusEnum = {
        Pending: 'PENDING',
        Ready: 'READY',
        Failed: 'FAILED'
    } as const;
    export type ProvisioningStatusEnum = typeof ProvisioningStatusEnum[keyof typeof ProvisioningStatusEnum];
}


